import { Entity, MicroMClient } from "@mcurros2/microm";
import { PerfilUsuarioDef } from "./PerfilUsuarioDef";

export class PerfilUsuario extends Entity<PerfilUsuarioDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new PerfilUsuarioDef(), parentKeys);
        this.Form = import('./PerfilUsuarioForm').then((module) => module.PerfilUsuarioForm);
        this.Title = "Tu perfil";
    }
}